(function($){

	$(document).ready(function(){

		if ("ontouchstart" in window || "ontouch" in window) { 

			$(document).on('click','#navigation-menu li a',function(e){
				if(!$(this).hasClass('has_dropdown') && $(this).attr('href') != '#') {

				} else {
					e.preventDefault();
					$('#navigation-menu li a').removeClass('open active');
					$(this).addClass('open');
					process_menu_hover_click($(this));
				}
			});

		} else {

			$('#navigation-menu .mega_menu .links').each(function(i, e){
				$links = $(this);
				$links_li = $links.find('li');

				$links_li.each(function(i,e){
					if($(this).find('.sub-menu').length) {
						$(this).addClass('has-tertiary-nav');
					}
				});
			});

			$('#navigation-menu .mega_menu .links li.has-tertiary-nav').on('mouseenter', function(e){
				$(this).closest('.links').addClass('active');
			}).on('mouseleave', function(e){
				$(this).closest('.links').removeClass('active');
			});


			$('#navigation-menu > li > a').hoverIntent(function() {
				if($(this).hasClass('has_dropdown')) {
					process_menu_hover_click($(this));	
				} else {
					process_header_lost_focus();
				}
			});	

			$('#navigation-menu > li > a').on('focus', function() {
				if($(this).hasClass('has_dropdown')) {
					process_menu_hover_click($(this));	
				} else {
					process_header_lost_focus();
				}
			});	
		}

		$(document).on('click','#body-overlay',function(e){
			$('#site-header').trigger('mouseleave');
		});

		function process_header_lost_focus() {
			$('#navigation-menu li.mega_menu_dropdown a.has_dropdown').removeClass('active').attr('aria-expanded', false);
			$('#navigation-menu li.menu-item-has-children').removeClass('active').find('> a').attr('aria-expanded', false);

			$('.pai-dropdown-menu').removeClass('active').attr('aria-hidden', true);
			
			$('#body-overlay').removeClass('active');
			$('body').removeClass('blur');
		}

		$(document).on('mouseleave','#navigation-menu',function(e){
			process_header_lost_focus();
		});

		$(document).on('focusout','#navigation-menu',function(e) {

			if(!document.querySelector('#navigation-menu').contains(e.relatedTarget)) {
				process_header_lost_focus();
			}
		});

		function process_menu_hover_click($obj) {

			$('#navigation-menu li.mega_menu_dropdown a.has_dropdown').removeClass('active').attr('aria-expanded', false);

			if($obj.hasClass('has_dropdown')) {
				var target = $obj.siblings('.mega_menu');
				$obj.addClass('active').attr('aria-expanded', true);
				$('body').addClass('blur');

				if(!$(target).hasClass('active')) {
					$('.pai-dropdown-menu').removeClass('active').attr('aria-hidden', true);
					$(target).addClass('active').attr('aria-hidden', false);
				}
			} else {
				$('.pai-dropdown-menu').removeClass('active').attr('aria-hidden', true);
			}
		}

	});
	
})(jQuery);